<template>
    <div>
        <div class="ml-auto mb-3 text-right">
            <exportCSV class="link btn buttons-csv buttons-html5 btn-primary mr-2"
                :data="exportData"
                :fields="exportFields"
                :header="exportHeaders"
                type="csv"
                :escapeCsv="false"
                :name="exportFileName">
                <span>CSV</span>
            </exportCSV>
            <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                <span class="mr-3">PDF</span>
                <i class="arrow-down fas fa-angle-down"></i> 
            </button> -->
        </div>
        <div class="row">
            <div v-show="false" class="col-sm-12 col-md-12 mb-2">
                <div class="dataTables_filter">
                    <label class="d-flex mb-0">
                        <input type="search" class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1" :placeholder="$t('label.search')" v-model="searchSales" @keypress.enter="filtersearchSales">
                        <button class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0 search" @click="filtersearchSales()">
                            <i class="fas fa-search"></i>
                        </button>
                    </label>
                </div>
            </div>
            <div class="col-sm-12 col-md-6 mb-2"> 
                <date-range-picker class="w-100"
                    :minDate="minDate"
                    ref="picker"
                    v-model="dateRange"
                    :opens="'right'"
                    :autoApply="true"
                    :showDropdowns="true" 
                    :always-show-calendars="false"
                    :locale-data="{firstDay: 1, format: 'dd/mm/yyyy'}"
                    @showCustomRange="showCustomRangeCalendars=true"
                    @update="filterByDate">
                </date-range-picker>
            </div>
            <div class="col-sm-12 col-md-6 mb-2">
                <div class="form-group">
                    <div class="input-group">
                        <div class="input-group-prepend w-100">
                            <label class="input-group-text border-right-0" for="serviceCategory">
                                <i class="fas fa-store"></i>
                            </label>
                            <multiselect  :value="selectedOutlet" label="text" track-by="id" :options="outlet" :searchable="false" :show-labels="false" openDirection="below" @select="filterByOutlet">
                                <template slot="option" slot-scope="{ option }">{{option.text}}</template>
                            </multiselect>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-6 mb-2">
                <div class="form-group">
                    <div class="input-group">
                        <div class="input-group-prepend w-100">
                            <label class="input-group-text border-right-0">
                                <i class="fas fa-cart-arrow-down"></i>
                            </label>
                            <multiselect  
                                v-model="selectedOrderType" 
                                :options="salesReportOrderTypes" 
                                label="text" track-by="id" 
                                :searchable="true" 
                                :show-labels="false" 
                                openDirection="below" 
                                @select="filterByOrderType">
                            </multiselect>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-6 mb-2">
                <div class="form-group">
                    <div class="input-group">
                        <div class="input-group-prepend w-100">
                            <label class="input-group-text border-right-0">
                                <i class="fas fa-list"></i>
                            </label>
                            <multiselect 
                                :value="selectedItemType" 
                                :options="salesReportItemTypes" 
                                label="text" track-by="id" 
                                :searchable="false" 
                                :show-labels="false" 
                                openDirection="below" 
                                @select="filterByItemType">
                            </multiselect>
                        </div>
                    </div>
                </div>
            </div> 
            <div v-show="false" class="col-sm-12 col-md-4 mb-2">
                <div class="form-group">
                    <div class="input-group">
                        <div class="input-group-prepend w-100">
                            <label class="input-group-text border-right-0" :style="selectedItemType.id == 'outstandings' ? 'opacity: 0.6' : {}">
                                <i class="fas fa-tag"></i>
                            </label>
                            <multiselect 
                                :disabled="selectedItemType.id == 'outstandings' ? true : false" 
                                :value="selectedCategory" 
                                :options="salesCategory" 
                                label="text" track-by="id" 
                                :searchable="false" 
                                :show-labels="false" 
                                openDirection="below" 
                                @select="filterByCategory">
                            </multiselect>
                        </div>
                    </div>
                </div>
            </div>    
            <div v-show="false" class="col-sm-12 col-md-4 mb-2">
                <div class="form-group">
                    <div class="input-group">
                        <div class="input-group-prepend w-100">
                            <label class="input-group-text border-right-0" :style="selectedItemType.id == 'outstandings' || selectedItemType.id == 'package' ? 'opacity: 0.6' : {}">
                                <i class="fas fa-tags"></i>
                            </label>
                            <multiselect 
                                :disabled="selectedItemType.id == 'outstandings' || selectedItemType.id == 'package' ? true : false" 
                                :value="selectedSubCategory" 
                                :options="salesSubCategory" 
                                group-values="subCategory" group-label="category" 
                                track-by="id" label="text" 
                                :show-labels="false" 
                                openDirection="below" 
                                @select="filterBySubCategory">
                                <span slot="noResult">{{$t('table.no_records')}}</span>
                            </multiselect>
                        </div>
                    </div>
                </div>
            </div>  
        </div>
        <a class="link text-primary" @click="clearFilter()">{{$t('button_link.clear_filter')}}</a>
        <ul v-show="showFilterPaymentType" class="nav nav-tabs mt-3" >
            <li class="nav-item" v-for="type in typeItems" :key="type.id">
                <a :class="{'active': selectedType.id == type.id}" class="nav-link" @click="filterByType(type)">{{type.text}}</a>
            </li>
        </ul>
    </div>
</template>
<script>
import moment from 'moment'
import _ from 'lodash';
import DateRangePicker from 'vue2-daterange-picker'
import tbl from '@/assets/js/dashboard/export-table-header.js'
import tab from '@/assets/js/dashboard/tab.js'
import cst, {calculateSalesReportTotal, getSubTotal, setSalesCommissionItems, calculateSalesReportDateTotal} from './../../../../assets/js/dashboard/salonReport/salonReport.js'
import {handleSessionExpired, getOutletName, getOutletList} from '@/assets/js/dashboard/dashboard.js'
import {insertLeadingZero, dateRange, reorderObject, setAYearArr, setYearArr} from '@/assets/js/dashboard/utilities.js'
import {getMinDate} from '@/assets/js/dashboard/utilities.js'
export default {
    name: "salesFilter",
    components:{
        DateRangePicker
    },
    props:{
        commissionSalesItem: { type: Array },
        tab: { type: String }
    },
    data(){
        let startDate = moment();
        let endDate = moment();
        return{
            minDate: getMinDate(),//moment().startOf('year').format('YYYY-MM-DD'),

            searchSales: "", 
            selectedType: {id: "", text: this.$i18n.t('salon_report.sales.sales')},
            dateRange: { startDate, endDate },
            outlet: [{id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')})}], selectedOutlet: {id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')})},
            selectedOrderType: {id: "all", text: this.$i18n.t('label.all', {'item': this.$t('subMenu.salon_report_order')})},
            selectedItemType: {id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.item_type')})},
            salesCategory: [], selectedCategory: {id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.category')})},
            objSubCategory: {},
            salesSubCategory: [
                {
                    category: this.$i18n.t('label.all', {'item': this.$i18n.t('label.category')}),
                    categoryID: "all",
                    subCategory: [{id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.subcategory')})}]
                }
            ], selectedSubCategory: {id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.subcategory')})},
            exportHeaders: [], exportFields: {}, exportFileName: "", exportData: [],
            showFilterPaymentType: true,
        }
    },
    computed:{
        typeItems(){
            return[
                {id: "", text: this.$i18n.t('salon_report.sales.sales')},
                {id: "credits", text: this.$i18n.t('salon_report.sales.credit_redeem')},
                {id: "package", text: this.$i18n.t('salon_report.sales.package_redeem')},
                {id: "all", text: this.$i18n.t('label.all', {'item': ''})},
            ]
        },
        salesReportItemTypes(){
            var arr = [{
                id: "all", 
                text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.item_type')})
            }]
            let type = this.$i18n.messages[this.$i18n.locale].salon_report.item_types
            for(var i in type){
                arr.push({
                    id: i,
                    text: type[i]
                })
            }
            return arr
        },
        salesReportOrderTypes(){
            var arr = [{
                id: "all", 
                text: this.$i18n.t('label.all', {'item': this.$t('subMenu.salon_report_order')})
            }]
            let type = this.$i18n.messages[this.$i18n.locale].salon_report.order_type
            for(var i in type){
                if(i === 'shop' || i === 'online') {
                    continue
                }
                
                arr.push({
                    id: i,
                    text: type[i]
                })
            }
            return arr
        }
    },
    watch:{
        "$i18n.locale"(val){
            this.outlet = [{id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')})}]
            this.outlet.push(...JSON.parse(this.$store.state.outlets))

            var b = Object.assign({}, this.selectedOutlet)
            this.selectedOutlet = this.outlet.filter(obj=> obj.id == b.id)[0]

            var a = Object.assign({}, this.selectedItemType)
            this.selectedItemType = this.salesReportItemTypes.filter(obj=> obj.id == a.id)[0]

            var c = Object.assign({}, this.selectedOrderType)
            this.selectedOrderType = this.salesReportOrderTypes.filter(obj=> obj.id == c.id)[0]

            if(this.selectedItemType.id != "outstandings"){
                this.setCategoryOptions(this.selectedItemType.id)
            }
            var d = Object.assign({}, this.selectedCategory)
            this.selectedCategory = this.salesCategory.filter(obj=> obj.id == d.id)[0]
            

            var e = Object.assign({}, this.selectedSubCategory)

            let type = this.$i18n.messages[this.$i18n.locale].salon_report.item_types

            for(var j=0; j<this.salesSubCategory.length; j++){
                this.salesSubCategory[j].category = this.salesSubCategory[j].categoryID == "all" ? this.$i18n.t('label.all', {'item': this.$i18n.t('label.category')}) : type[this.salesSubCategory[j].categoryID]
                for(var k=0; k<this.salesSubCategory[j].subCategory.length; k++){
                   if(this.salesSubCategory[j].subCategory[k].id == "all"){
                       this.salesSubCategory[j].subCategory[k].text = this.$i18n.t('label.all', {'item': this.$i18n.t('label.subcategory')})
                   }
                }
            }
            for(var i=0; i<this.salesSubCategory.length; i++){
                if(this.salesSubCategory[i].categoryID == this.selectedCategory.id){
                    this.selectedSubCategory = this.salesSubCategory[i].subCategory.filter(obj=> obj.id == e.id)[0]
                }
            }
            this.getExportData()
        }
    },
    methods:{
        clearFilter(){
            let startDate = moment();
            let endDate = moment();

            this.searchSales = ""
            this.selectedType = {id: "", text: "Sales"}
            this.dateRange = { startDate, endDate };
            this.selectedOutlet = {id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')})}
            this.selectedOrderType = {id: "all", text: this.$i18n.t('label.all', {'item': this.$t('subMenu.salon_report_order')})}
            this.selectedItemType = {id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.item_type')})}
            this.selectedCategory = {id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.category')})}
            this.selectedSubCategory = {id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.subcategory')})}

            this.filterByItemType(this.selectedItemType)
            this.setFilter();
        },
        setFilter(){
            var data = {
                search: this.searchSales,
                startDate: this.dateRange.startDate,
                endDate: this.dateRange.endDate,
                type: this.selectedType.id,
                outlet: this.selectedOutlet.id,
                itemType: this.selectedItemType.id,
                category: this.selectedCategory.id,
                folderID: this.selectedSubCategory.id,
                voided: this.selectedOrderType.id
            }
            this.$emit('filterSalesCommission', data)
        },
        filtersearchSales(){
            if(this.searchSales != ""){
                this.setFilter()
            }
        },
        filterByType(item){
            this.selectedType = item;
            this.searchSales = "";
            this.setFilter();
        },
        filterByDate(date){
            date.startDate = moment(date.startDate)
            date.endDate = moment(date.endDate)
            this.dateRange = date;
            this.searchSales = "";
            this.setFilter();
        },
        filterByOutlet(item){
            this.selectedOutlet = item;
            this.searchSales = "";
            this.setFilter();    
        },
        filterByOrderType(item){
            this.selectedOrderType = item
            this.setFilter();    

            this.showFilterPaymentType = item.id === 'voided' ? false : true
        },
        filterByItemType(item){
            this.selectedItemType = item;
            this.searchSales = "";
            if(item.id != "outstandings"){
                this.selectedCategory = {id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.category')})}
                this.setCategoryOptions(item.id)
                this.setSubCategoryOptions(item.id)
            }
            this.setFilter()
        },
        async filterByCategory(item){
            this.searchSales = "";
            this.selectedCategory = item;
            this.selectedSubCategory = {id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.subcategory')})}
            this.setFilter();
            var strFilter = item.id == "all" ? "" : "&category=" + item.id;

            this.salesSubCategory = [];
            let objType = this.$i18n.messages[this.$i18n.locale].salon_report.item_types

            if(this.selectedItemType.id == "all"){
                if(item.id == "all"){
                    this.setSubCategoryOptions(item.id)
                }else{
                    for(var type in this.objSubCategory){
                        if(type != "package"){
                            var subCategory = await this.getSubCategory(type, strFilter)
                            var arrSub = [{id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.subcategory')})}];
                            arrSub.push(...subCategory)
                            this.salesSubCategory.push(
                                {
                                    category: objType[type],
                                    categoryID: type,
                                    subCategory: arrSub
                                }
                            ) 
                        }
                    }   
                }
            }else{
                if(this.selectedItemType.id != "package"){
                    var subCat = await this.getSubCategory(this.selectedItemType.id, strFilter)
                    var sub = [{id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.subcategory')})}];
                    sub.push(...subCat)
                    this.salesSubCategory.push(
                        {
                            category: item.text,
                            categoryID: item.id,
                            subCategory: sub
                        }
                    ) 
                }
            }
            
        },
        filterBySubCategory(item){
            this.searchSales = "";
            this.selectedSubCategory = item;
            this.setFilter()
        },
        setCategoryOptions(itemType){
            this.salesCategory = [];
            this.salesCategory.push({id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.category')})});
            if(itemType == "all"){
                for(var i=0; i<6; i++){
                    this.salesCategory.push({
                        id: i,
                        text: this.$i18n.t('label.category') + ' ' + (i+1)
                    })
                }
            }else{
                var categoryList = JSON.parse(this.$store.state.category);
                var category = categoryList[itemType]
                for(var j=0; j<category.length; j++){
                    this.salesCategory.push({
                        id: j,
                        text: this.$i18n.t('label.category') + " " + (j+1) +  " - " + category[j]
                    })
                }
            } 
        },
        setSubCategoryOptions(itemType){
            this.salesSubCategory = [];
            let objType = this.$i18n.messages[this.$i18n.locale].salon_report.item_types
            if(itemType == "all"){
                this.salesSubCategory.push({
                    category: this.$i18n.t('label.all', {'item': this.$i18n.t('label.category')}),
                    categoryID: "all",
                    subCategory: [{id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.subcategory')})}]
                })
                for(var type in this.objSubCategory){
                    this.salesSubCategory.push(
                        {
                            // category: type.charAt(0).toUpperCase() + type.slice(1),
                            category: objType[type],
                            categoryID: type,
                            subCategory: this.objSubCategory[type]
                        }
                    )   
                }
            }
            else{
                var subCategory = [{id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.subcategory')})}];
                subCategory.push(...this.objSubCategory[itemType])
                this.salesSubCategory.push(
                    {
                        // category: itemType.charAt(0).toUpperCase() + itemType.slice(1),
                        category: objType[itemType],
                        categoryID: itemType,
                        subCategory: subCategory
                    }
                ) 
            }
        },
        async getAllSubCategory(){
            for(var i=1; i<this.salesReportItemTypes.length - 1; i++){
                var type = this.salesReportItemTypes[i].id
                var subCategory = await this.getSubCategory(type, "")
                this.objSubCategory[type] = subCategory
            }
            this.setSubCategoryOptions("all")
        },
        async getSubCategory(type, category){
            let $vm = this
            type = type == "service" ? "" : "type=" + type;
            
            var QUERY_STRING = "?" + type + category;
            const url =  this.$api.MENU_FOLDER + QUERY_STRING;

            var res = [];
            await this.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: this.$util.getSessionToken()}
            })
            .then(function(response) {
                var results = response.data.folder;

                for(var i=0; i<results.length; i++){
                    res.push({id: results[i].folderID, text: results[i].title})
                }    
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return res;
        },
        getExportData(){
            var exportData = this.setExportData(this.commissionSalesItem, this.tab)
            return exportData
        },
        async setExportData(items, tab){
            var $vm = this
            var exportData = []
            await getOutletList(this)
            var outlet = JSON.parse(this.$store.state.outlets)
            var startDate = this.dateRange.startDate.toDate()
            var endDate = this.dateRange.endDate.toDate()

            switch(tab){
                case"date":
                    this.exportFields = tbl.exportSalesReportDateTblHdr
                    exportData = items
                break;
                case"item":
                    this.exportFields = tbl.exportSalesReportItemTblHdr
                    for(var i=0; i<items.length; i++){
                        exportData.push(
                            {
                                index: i+1,
                                date: moment(items[i].createDate*1000).format(this.$msg.CST.DATE_TIME_24),
                                receiptNo: insertLeadingZero(items[i].receiptID),
                                title: items[i].item.title,
                                outlet: getOutletName(items[i].outletID, outlet),
                                memberName: items[i].member.displayName,
                                mobile: items[i].member.mobile,
                                price: items[i].price,
                                discount: items[i].discount,
                                outstandings: items[i].outstandings,
                                tax: items[i].tax.tax,
                                taxType: this.getTaxType(items[i].tax.taxType),
                                subtotal: getSubTotal(items[i].price, items[i].discount, items[i].outstandings, items[i].tax.taxType, items[i].tax.tax)
                            }
                        )
                    }
                    var objTotal = calculateSalesReportTotal(items)
                    exportData.push(
                        {
                            index: "",
                            date: "",
                            receiptNo: "",
                            title: "",
                            outlet: "",
                            memberName: "",
                            mobile: this.$i18n.t('label.total'),
                            price: objTotal.totalPrice,
                            discount: objTotal.totalDiscount,
                            outstandings: objTotal.totalOutstandings,
                            tax: objTotal.totalTax,
                            taxType: "",
                            subtotal: objTotal.subTotal
                        }
                    )
                break;
            }
            var arrTab = this.$i18n.messages[this.$i18n.locale].tab.reportSalesTabs
            var viewBy = arrTab.filter(obj=> obj.id == tab)[0]
            this.exportData = exportData
            var strDate = moment(startDate).format(this.$msg.CST.DATE_FORMAT) + " - " + moment(endDate).format(this.$msg.CST.DATE_FORMAT);
            let header = this.$msg.REPORT.HEADER + this.$i18n.t('subMenu.salon_report_sales')
            this.exportHeaders = [
                header, 
                this.$i18n.t('table.header.date') + ": " + strDate , 
                this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24), 
                this.$i18n.t('label.outlet') + ": " + (this.selectedOutlet.id == "all" ? this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')}) : getOutletName(this.selectedOutlet.id, outlet)), 
                this.$i18n.t('salon_report.view') + viewBy.text, 
                " "
            ];
            this.exportFileName = header.split(" ").join("_") + "_" + strDate +  this.$msg.REPORT.CSV

            // return exportData
        },
        getTaxType(taxType){
            var strTax = ""
            switch(taxType){
                case"exclusiveTax":
                strTax = this.$i18n.t('salon_report.tax.exclusive')
                break;
                case"inclusiveTax":
                strTax = this.$i18n.t('salon_report.tax.inclusive')
                break;
                default:
                strTax = this.$i18n.t('salon_report.tax.no_tax')
                break;
            }
            return strTax;
        }
    },
    async mounted(){
        let $vm = this;
        await getOutletList($vm)
        var outlets = JSON.parse($vm.$store.state.outlets);
        $vm.outlet.push(...outlets);
        $vm.setCategoryOptions("all")
        $vm.getAllSubCategory();

        if (this.outlet[1]) {
            this.selectedOutlet = this.outlet[1]
        }

        this.$nextTick(() => {
            this.setFilter()
        })
    }
}
</script>
<style scoped>
.link, .nav-item{
    cursor: pointer;
}

.search:hover{
    background: #d6d6d6;
    border: 1px solid #d6d6d6;
}

.export-button{
    margin-top: -4.15em;
    margin-left: 1em;
}
.visible-card{
    overflow: visible !important;
}
</style>